import * as React from 'react';

function Dashboard(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={16} height={17} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.188.375c.914 0 1.687.773 1.687 1.688v5.624c0 .95-.773 1.688-1.688 1.688H1.813c-.949 0-1.687-.738-1.687-1.688V2.063c0-.914.738-1.687 1.688-1.687h3.375zm9 6.75c.914 0 1.687.773 1.687 1.688v5.624c0 .95-.773 1.688-1.688 1.688h-3.374c-.95 0-1.688-.738-1.688-1.688V8.814c0-.915.738-1.688 1.688-1.688h3.374zM.124 13.313c0-.915.738-1.688 1.688-1.688h3.375c.914 0 1.687.773 1.687 1.688v1.124c0 .95-.773 1.688-1.688 1.688H1.813c-.949 0-1.687-.738-1.687-1.688v-1.124zM14.188.374c.914 0 1.687.773 1.687 1.688v1.124c0 .95-.773 1.688-1.688 1.688h-3.374c-.95 0-1.688-.738-1.688-1.688V2.063c0-.915.738-1.688 1.688-1.688h3.374z"
        fill="#BDBDBD"
      />
    </svg>
  );
}

export default Dashboard;
